import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { EnvironmentService } from 'src/app/core/enviroment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class ProductsService {

  private uri = this.environmentService.getEnvVar('api_products');

  constructor(private http: HttpClient,
              private environmentService: EnvironmentService) { }

  autoCompleteByNameOrAddress(searchTerm: string) {
    return this.http.get(`${this.uri}/register-product/autocomplete?max_items=20&search=${searchTerm}`);
  }

    searchByName(data?) {
    let params = new HttpParams();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        params = params.append(key, data[key]);
      }
    }
    params = params.append('rand', Math.random().toString());
    return this.http.get(`${this.uri}/products`, {params});
  }
}
